import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-refer-a-friend-layout',
    templateUrl: './refer-a-friend-layout.component.html',
    styleUrls: ['../../app.component.scss'],
    standalone: false
})
export class ReferAFriendLayoutComponent {
  @Input() currentUrl: string;
}
